(function () {
  'use strict';

  if (window.__LSAccessoryContributionLoaded) return;
  window.__LSAccessoryContributionLoaded = true;

  const config = window.LSAccessoryContributionConfig || {};
  const feeVariantId = Number(config.feeVariantId || 0);
  const accessoryProductIds = (config.accessoryProductIds || [])
    .map((value) => Number(value || 0))
    .filter((value) => value > 0);
  const cartUpdateError = String(
    config.cartUpdateError || 'Your cart could not be updated. Please try again.'
  );
  const sourceName = 'ls-accessory-contribution';

  if (!feeVariantId || accessoryProductIds.length === 0) {
    console.error('[Love Smiths] Missing accessory handling-fee configuration.');
    return;
  }

  if (!window.LSCartState) {
    console.error('[Love Smiths] The shared cart-state controller is unavailable.');
    return;
  }

  function getRootUrl() {
    return window.Shopify?.routes?.root || '/';
  }

  function isFee(item) {
    return Number(item.variant_id || item.id) === feeVariantId;
  }

  function isAccessory(item) {
    return accessoryProductIds.includes(Number(item.product_id || 0));
  }

  function analyse(cart) {
    const feeItems = [];
    let hasAccessory = false;
    let hasNormalProduct = false;

    cart.items.forEach((item) => {
      if (isFee(item)) {
        feeItems.push(item);
        return;
      }

      if (Number(item.quantity || 0) <= 0) return;

      if (isAccessory(item)) hasAccessory = true;
      else hasNormalProduct = true;
    });

    return {
      feeItems,
      needsFee: hasAccessory && !hasNormalProduct,
    };
  }

  async function addFee() {
    await window.LSCartState.requestJSON(`${getRootUrl()}cart/add.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: feeVariantId,
            quantity: 1,
            properties: {
              _ls_accessory_contribution: 'true',
            },
          },
        ],
      }),
    });

    window.LSCartState.invalidate();
    return window.LSCartState.getCart({ force: true });
  }

  async function setFeeLines(feeItems, keepOne) {
    const updates = {};

    feeItems.forEach((item, index) => {
      updates[item.key] = keepOne && index === 0 ? 1 : 0;
    });

    const cart = await window.LSCartState.requestJSON(`${getRootUrl()}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    });

    return cart;
  }

  async function normaliseAccessoryContribution(cart) {
    const state = analyse(cart);

    if (state.needsFee && state.feeItems.length === 0) {
      return { cart: await addFee(), changed: true };
    }

    if (!state.needsFee && state.feeItems.length > 0) {
      return { cart: await setFeeLines(state.feeItems, false), changed: true };
    }

    if (state.needsFee && state.feeItems.length > 0) {
      const totalFeeQuantity = state.feeItems.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );

      if (state.feeItems.length !== 1 || totalFeeQuantity !== 1) {
        return { cart: await setFeeLines(state.feeItems, true), changed: true };
      }
    }

    return { cart, changed: false };
  }

  function moveFeeRowsToEnd() {
    const selector = `[data-quantity-variant-id="${feeVariantId}"]`;

    document.querySelectorAll(selector).forEach((input) => {
      const feeRow = input.closest('.cart-item');
      if (!feeRow?.parentElement) return;

      const parent = feeRow.parentElement;
      const cartRows = [...parent.children].filter((child) => child.classList?.contains('cart-item'));
      const lastCartRow = cartRows[cartRows.length - 1];

      if (lastCartRow && lastCartRow !== feeRow) {
        lastCartRow.insertAdjacentElement('afterend', feeRow);
      }
    });
  }

  function hideFeeControls() {
    const selector = `[data-quantity-variant-id="${feeVariantId}"]`;

    document.querySelectorAll(selector).forEach((input) => {
      input.value = '1';
      input.setAttribute('value', '1');
      input.disabled = true;

      const row = input.closest('.cart-item');
      if (!row) return;

      row.setAttribute('data-ls-accessory-contribution', 'true');

      row.querySelectorAll('.quantity__button').forEach((button) => {
        button.hidden = true;
        button.disabled = true;
      });

      row.querySelectorAll('cart-remove-button').forEach((removeControl) => {
        removeControl.hidden = true;
      });
    });

    moveFeeRowsToEnd();
  }

  function shouldSynchroniseOnLoad() {
    return config.pageType === 'cart';
  }

  async function synchroniseInitialCart() {
    if (!shouldSynchroniseOnLoad()) return;

    try {
      const result = await window.LSCartState.sync({
        force: false,
        source: `${sourceName}-initial`,
        notify: false,
        emitAdjusted: true,
      });

      if (!result.changed) {
        window.LSCartState.notify(result.cart, `${sourceName}-initial`, {
          publish: false,
        });
      }
    } catch (error) {
      console.error('[Love Smiths] Accessory handling-fee error:', error);
    }
  }

  window.LSCartState.registerNormalizer(sourceName, normaliseAccessoryContribution);

  document.addEventListener('ls:cart-updated', hideFeeControls);
  document.addEventListener('ls:cart-rendered', hideFeeControls);

  document.addEventListener(
    'click',
    async (event) => {
      if (!event.target || typeof event.target.closest !== 'function') return;

      const checkoutButton = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
      );

      if (!checkoutButton) return;

      event.preventDefault();
      event.stopPropagation();

      try {
        window.LSCartState.invalidate();
        await window.LSCartState.sync({
          force: true,
          source: `${sourceName}-checkout`,
          notify: false,
          emitAdjusted: false,
        });
        window.location.href = `${getRootUrl()}checkout`;
      } catch (error) {
        console.error('[Love Smiths] Checkout preparation error:', error);
        window.alert(cartUpdateError);
      }
    },
    true
  );

  function start() {
    hideFeeControls();
    synchroniseInitialCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
